/**
 * This is the main entry point responsible for wiring up the root component of the app.
 */

import './styles/main.css'

import '@wf-common/atoms/dist/common-atoms.css'
import '@wf-sl/common-icons/dist/wf-sl-common-icons.css'
import '@wf-sl/common-organisms/dist/common-organisms.css'
import '@wf-sl/common-utilities/dist/common-utilities.css'
import '@wf-sm/app-switcher/dist/appswitcher.css'
import '@wf-sm/base/dist/baseui.css'
import 't3-connected-widgets/dist/t3-connected-widgets.css'
import 't3-widgets/dist/t3-widgets.css'

import React from 'react'
import cssVars from 'css-vars-ponyfill'
import { setAutoFreeze } from 'immer'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import createLogger from 'redux-logger'

import { Globals } from '@wf-sl/common-utilities'

import { hasCssCustomProperties } from './common/utils/css-vars'
import './globals-setup'
import { MainView } from './modules/main/module'
import { store } from './redux/store'

const isDev = Globals.get('NODE_ENV') !== 'production'

// Log version info
// logger.log('Version: ', Globals.get('VERSION'))

// https://immerjs.github.io/immer/freezing/
setAutoFreeze(isDev)

// Provide client-side support for CSS custom properties in legacy browsers
// See also https://github.com/jhildenbiddle/css-vars-ponyfill
if (!hasCssCustomProperties()) {
    cssVars({
        onError: function (message, node, xhr, url) {
            if (isDev) {
                console.warn('cssVars error', message, node, xhr, url)
            }
        },
        onlyLegacy: true,
        watch: true
    })
}

// Setup root component
function createRoot() {
    return function Root() {
        return (
            <Provider store={store}>
                <MainView />
            </Provider>
        )
    }
}

// Setup supported locales for localized formatting with Modux
// ATTENTION: If any locale is removed/added please also update the copy:locale script of the package.json
// const supportedLocales = ['de-DE', 'en-GB', 'en-US', 'es-ES', 'nl-NL', 'pl-PL']

// Enable Redux debug logging in browser console depending on Globals (either by build config or URL query parameter)
const enableReduxLogger = Globals.get('REDUX_LOGGER')

const reduxMiddleWares = []
if (enableReduxLogger) {
    reduxMiddleWares.push(createLogger())
}

// Bootstrap and mount root component
Promise.all([
    // fetch translations!
    // dispatch(createFetchWebConfigThunk())
    // dispatch(createInitializeIntlThunk(translationActions.changeLocale, supportedLocales))
]).then(() => {
    const Root = createRoot()
    // store
    ReactDOM.render(<Root />, document.getElementById('app'))
})
